import {SectorGraphics} from 'constants/url';
import Axios from 'axios';

async function getGraphicsSector(token, values) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await Axios.post(
      SectorGraphics,
      JSON.stringify(JSON.stringify(values)),
      {
        headers,
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

export default getGraphicsSector;
